module.exports = __webpack_public_path__ + "img/3.72fa8394.png";